// extracted by mini-css-extract-plugin
export default {"container":"container__aKwaX","logs":"logs__2A6Xa","bold":"bold__N09zT"};